export function checkForDuplicateIds() {
    const toCeckWrappers = document.querySelectorAll('[data-check-id-duplicates]');
    toCeckWrappers.forEach(wrapper => {
        const ids = new Set();
        const elements = wrapper.querySelectorAll('[id]');
        elements.forEach(element => {
            const id = element.id;
            if (ids.has(id)) {
                console.warn('Duplicate id', id, element);
            }
            else {
                ids.add(id);
            }
        });
    });
}
//# sourceMappingURL=check-for-duplicate-ids.js.map